import { useContext, Context } from 'react';
import { ViewModel } from '@steelbuy/ts-shared';

import { EntityDataProviderValue } from '../provider/EntityDataProviderValue';

export const useEntityData = <Model extends ViewModel>(
    v: Context<EntityDataProviderValue<Model>>
): EntityDataProviderValue<Model> => useContext(v);
